import React, { useEffect, useState } from 'react';
import firebaseApp, { getIdToken } from './../../helpers/auth.js';
import { fetchAPI } from '../../ducks/api.js';

export const AuthContext = React.createContext();

export const AuthProvider = ({
  children,
  isRegistration,
  loadUser,
  isAuthenticated,
}) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [pending, setPending] = useState(true);

  useEffect(() => {
    const unsubscribe = firebaseApp.auth().onAuthStateChanged(async (user) => {
      console.log(`Registration: ${isRegistration}`);
      setPending(true);

      if (user && isRegistration) {
        try {
          const token = await getIdToken();
          window.localStorage.setItem('token', token);
        } catch (error) {
          // The Firebase credential can be revoked mid-registration — the
          // assessment completion sets the user's password (server-side
          // getAuth.updateUser), which invalidates the current token
          // (auth/user-token-expired). Registration already succeeded
          // server-side, so swallow it instead of throwing unhandled — and
          // still clear `pending` in finally (matches the logged-in branch).
        } finally {
          setPending(false);
        }
        return;
      }

      if (user && !isRegistration) {
        try {
          console.log('Will fetch api');
          const token = await getIdToken();
          window.localStorage.setItem('token', token);
          const userResponse = await fetchAPI('/auth/');
          setCurrentUser(userResponse);
          loadUser();
        } catch (error) {
          setCurrentUser(null);
        } finally {
          setPending(false);
        }
      } else {
        console.log(`Hitting else`);
        setCurrentUser(null);
        setPending(false);
      }
    });

    return () => unsubscribe();
  }, [isRegistration, loadUser]);

  useEffect(() => {
    if (!isAuthenticated) {
      loadUser();
    }
  }, [isAuthenticated]);

  return (
    <AuthContext.Provider value={{ currentUser, pending }}>
      {children}
    </AuthContext.Provider>
  );
};
